<template>
    <div class="membres-index">
        <header page-transition-group>
            <HeroGraphicText v-if="contentIsLoaded && content.heroGraphicText != null" />
        </header>

        <div class="page-content" page-transition-group>
            <section>
                <div class="container-xxl padding-container-top">
                    <div
                        class="row default-fliters-wrapper align-items-center justify-content-md-between px-lg-4"
                    >
                        <div
                            class="col-12 col-xxl-auto d-flex align-items-center justify-content-center justify-content-md-start mb-4 mb-xxl-0"
                        >
                            <IconInis name="filter" />
                            <span class="d-inline-block text-uppercase bold ms-3">{{
                                $t('Filtres')
                            }}</span>
                        </div>

                        <div
                            class="col-12 col-lg-auto d-flex flex-column flex-md-row align-items-center mb-5 mb-lg-0"
                        >
                            <!-- <div
                                class="d-flex flex-column flex-xl-row align-items-center col-select mb-4 mb-md-0 me-md-2"
                            >
                                <span
                                    class="text-weight-semibold text-small me-md-auto me-xl-2 ms-md-1 mb-2 mb-xl-0"
                                    >{{ $t('Choisir une catégorie') }}</span
                                >
                                <div class="select-wrapper">
                                    <select>
                                        <option value="">{{ $t('Toutes les catégories') }}</option>
                                        <option value="">{{ $t('option-01') }}</option>
                                        <option value="">{{ $t('option-02') }}</option>
                                    </select>
                                </div>
                            </div> -->

                            <div
                                class="d-flex flex-column flex-xl-row align-items-center col-select ms-md-2"
                            >
                                <span
                                    class="text-weight-semibold text-small me-md-auto me-xl-2 ms-md-1 mb-2 mb-xl-0"
                                    >{{ $t('Choisir un type') }}</span
                                >
                                <div class="select-wrapper">
                                    <select @change="goToPage(1)" v-model="filters.type">
                                        <option value="">{{ $t('Tout les types') }}</option>
                                        <option :value="item" v-for="(item, i) in aggregateTypes" :key="i">{{ item }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-auto">
                            <div
                                class="d-flex flex-column justify-content-center flex-md-row justify-content-md-start align-items-md-center"
                            >
                                <!-- <button class="button">{{ $t('Afficher') }}</button> -->
                                <button class="button-underline-red mt-3 mt-md-0 ms-md-3" @click.prevent="resetFilters()">
                                    {{ $t('Réinitialiser') }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div
                        class="row align-items-center justify-content-center justify-content-md-between padding-container-sm"
                        v-if="membresListing && membresListing.items && membresListing.items.length > 0"
                    >

                        <div class="col-auto">
                            <span>{{ (currentPage * perPage) + 1 + ' ' + $t('à') }}</span>&nbsp;<span v-if="(currentPage + 1) * perPage > membresListing.pagination.totalResults">{{membresListing.pagination.totalResults}}</span>
                            <span v-else>{{ (currentPage + 1) * perPage }}</span>&nbsp;<span>{{ $t('de') + ' ' + membresListing.pagination.totalResults }}</span>
                        </div>

                        <div
                            class="col-12 col-md-auto d-flex align-items-center justify-content-center flex-column flex-md-row mt-3 mt-md-0"
                        >
                            <span class="me-md-4 mb-2 mb-md-0">{{ $t('Trier par') }}</span>
                            <div class="select-wrapper">
                                <select @change="goToPage(1)" v-model="filters.order">
                                    <option value="a-z">{{ $t('Ordre alphabétique A-Z') }}</option>
                                    <option value="z-a">{{ $t('Ordre alphabétique Z-A') }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="sep-hor-thick-black mt-3"></div>
                        </div>
                    </div>

                    <div class="row results-row">
                        <MemberCard
                            v-for="(member, index) in membresListing.items"
                            :key="'member-' + index"
                            :memberData="member"
                        />

                        <div class="pagination-loader" :class="{ 'is-loading': isLoading }">
                            <StairInis />
                        </div>
                    </div>

                    <div class="row justify-content-md-between padding-container-bottom" v-if="membresListing.pagination && membresListing.pagination.totalPages > 1">

                        <div class="col-12 col-md-6 d-flex align-items-center justify-content-center justify-content-md-start mb-5 mb-md-0">
                            <span>{{ (currentPage * perPage) + 1 + ' ' + $t('à') }}</span>
                            &nbsp;
                            <span v-if="(currentPage + 1) * perPage > membresListing.pagination.totalResults">
                                {{membresListing.pagination.totalResults}}
                            </span>
                            <span v-else>
                                {{ (currentPage + 1) * perPage }}
                            </span>
                            &nbsp;
                            <span>
                                {{ $t('de') + ' ' + membresListing.pagination.totalResults }}
                            </span>
                        </div>

                        <!-- <div class="col-12 col-md-auto">{{ membresListing.pagination.totalResults }} résultats</div> -->
                        <div class="col-12 col-md-auto pagination-wrap">
                            <a class="pagination-item icon" href="#" v-if="currentPage > 0" @click.prevent="goToPage('prev')"><i class="fa-regular fa-chevron-left fa-2x"></i></a>

                            <a class="pagination-item" :class="{ 'disabled': currentPage === 0 }" :href="'?p=' + 1" @click.prevent="goToPage(1)">1</a>

                            <a class="pagination-item space" href="#" v-if="currentPage >= 5" @click.prevent>...</a>

                            <a class="pagination-item" v-for="i in membresListing.pagination.previousPages" :key="i" :href="'?p=' + i" :class="{ disabled: i === (currentPage + 1) }" @click.prevent="goToPage(i)">{{ i }}</a>
                            <a class="pagination-item" v-for="i in membresListing.pagination.nextPages" :key="i" :href="'?p=' + i" :class="{ disabled: i === (currentPage + 1) }" @click.prevent="goToPage(i)">{{ i }}</a>

                            <a class="pagination-item space" href="#" v-if="currentPage <= membresListing.pagination.totalPages - 5" @click.prevent>...</a>

                            <a class="pagination-item" :class="{ 'disabled': currentPage === (membresListing.pagination.totalPages - 1) }" :href="'?p=' + membresListing.pagination.totalPages" @click.prevent="goToPage(membresListing.pagination.totalPages)">{{membresListing.pagination.totalPages}}</a>

                            <a class="pagination-item icon" href="#" v-if="(currentPage + 1) < membresListing.pagination.totalPages" @click.prevent="goToPage('next')"><i class="fa-regular fa-chevron-right fa-2x"></i></a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { getAllDocs } from '@/firebase/init'

import StairInis from '@/components/svgs/stairInis'
import MemberCard from '@/components/loopTemplate/MemberCard'
import IconInis from '@/components/svgs/IconInis'
import HeroGraphicText from '@/components/hero/HeroGraphicText.vue'

export default {
    name: 'Membres',

    components: {
        // AssetLoader,
        HeroGraphicText,
        IconInis,
        MemberCard,
        StairInis,
    },

    data() {
        return {
            // Firebase Firestore
            firestoreContent: [],
            firestoreErr: null,
            // Membres
            membres: [],
            filters: {
                type: '',
                order: 'a-z',
            },
            // Pagination
            perPage: 24,
            currentPage: 0,
            isLoading: false,
        }
    },

    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    this.setBgTheme(this.content.heroGraphicText.heroBackgroundColor)
                    if (this.$route.query.p) {
                        this.currentPage = parseInt(this.$route.query.p) - 1
                    }

                    if (this.$route.meta.firebaseCollection) {
                        try {
                            const res = await getAllDocs(
                                this.$route.meta.firebaseCollection,
                                this.$route.meta.firebaseDocument
                            )
                            this.firestoreContent = res
                            this.setFirestoreContentLoaded(true)
                            this.setFirestoreContentData(this.firestoreContent)
                        } catch (e) {
                            this.firestoreErr = e
                        }
                    }
                }
            },
            immediate: true,
        },
    },

    computed: {
        membresListing() {
            if (!this.contentIsLoaded) {
                return []
            }

            const { type, order } = this.filters

            let membres = this.firestoreContent.filter(
                (membre) =>
                    (!type || membre.type.includes(type))
            )

            if (order === 'a-z') {
                membres = membres.sort((a, b) => {
                    return a.lName.localeCompare(b.lName)
                })
            } else {
                membres = membres.sort((a, b) => {
                    return b.lName.localeCompare(a.lName)
                })
            }

            const totalResults = membres.length
            const totalPages = Math.ceil(totalResults / this.perPage)

            const nextPages = []
            let previousPages = []

            for (let i = 1; i <= 3; i++) {
                if (this.currentPage + i < totalPages && this.currentPage + i !== totalPages && this.currentPage + i !== 1 && this.currentPage + i !== 0) {
                    nextPages.push(this.currentPage + i)
                }
                if ((this.currentPage + 1) - i >= 0 && (this.currentPage + 1) - i !== 1 && (this.currentPage + 1) - i !== 0) {
                    previousPages.push((this.currentPage + 1) - i)
                }
            }

            previousPages = previousPages.reverse()

            return {
                items: membres.slice(
                    this.currentPage * this.perPage,
                    (this.currentPage + 1) * this.perPage
                ),
                pagination: {
                    perPage: this.perPage,
                    currentPage: this.currentPage,
                    totalResults,
                    totalPages,
                    nextPages,
                    previousPages,
                },
            }
        },
        aggregateTypes() {
            if (!this.contentIsLoaded) {
                return []
            }

            const types = []
            const members = this.firestoreContent
            members.forEach(member => {
                const typesList = member.type.split(';')
                typesList.forEach(type => {
                    if (!types.includes(type)) {
                        types.push(type)
                    }
                })
            })

            const sortValues = {
                'Diplômé·e': 1,
                'Formateur·trice': 2,
                'Étudiant·e': 3,
                'Autre': 4
            }

            types.sort((a, b) => {
                return sortValues[a] - sortValues[b]
            })

            return types
        },
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals', 'firestoreContentLoaded', 'firestoreContentData']),
    },

    methods: {
        goToPage(page) {
            this.isLoading = true
            // ScrollTo
            document.querySelector('.page-content').scrollIntoView({
                top: 0,
                behavior: 'smooth',
            })

            if (page === 'prev') {
                this.currentPage--
            } else if (page === 'next') {
                this.currentPage++
            } else {
                this.currentPage = page - 1
            }

            const url = new URL(window.location.href.split('?')[0])
            url.searchParams.set('p', (this.currentPage + 1))
            window.history.pushState({}, '', url);

            // const cardsImg = document.querySelectorAll('.card-header img')
            // cardsImg.forEach(img => {
            //     img.setAttribute('src', '/static-assets/ws.jpg')
            // })

            setTimeout(() => {
                this.isLoading = false
            }, 3295)
        },
        resetFilters() {
            this.goToPage(1)
            this.filters = {
                type: '',
                order: 'a-z',
            }
        },
        ...mapActions(['setErrorsReportMsg', 'setBgTheme', 'setFirestoreContentLoaded', 'setFirestoreContentData']),
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/styles/base/_variables.scss';

</style>
